function scrollButton () {
                              
    this.small = window.matchMedia('(max-width: 749px)');
    
    if (this.small.matches) {  
      function offset(el) {
        var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
      }
      const fakeButton = document.querySelector('.product-form__radios-button.fake-button-responsive');
      var fakeButtonBottom = offset(fakeButton);
      window.scrollTo({top: (fakeButtonBottom.top - window.innerHeight) + 150, behavior: 'smooth'});
    }
}

function fakeButtonRespo () {
    const productForms = document.querySelectorAll('.product-form form.form');
    productForms.forEach((productForm) => {
      if (productForm.classList.value.includes('js-submit-choose')) productForm.classList.remove('js-submit-choose');
    });
    document.querySelector('.product-form').classList.remove('js-submit-choose'); document.body.classList.add('overflow-custom'); 
    document.querySelector('.product-form__radios.size-radios').classList.add('open');
    if (document.querySelector('.product-form__radios.size-radios input:checked')) {
      document.querySelector('.product-form__radios.size-radios input:checked').checked = false;
    }
}


document.addEventListener('DOMContentLoaded', function() {
    function isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      const trident = ua.indexOf('Trident/');
      return (msie > 0 || trident > 0);
    }
    if (!isIE()) return;
    const hiddenInput = document.querySelector('#{{ product_form_id }} input[name="id"]');
    const noScriptInputWrapper = document.createElement('div');
    const variantSwitcher = document.querySelector('variant-radios[data-section="{{ section.id }}"]') || document.querySelector('variant-selects[data-section="{{ section.id }}"]');
    noScriptInputWrapper.innerHTML = document.querySelector('.product-form__noscript-wrapper-{{ section.id }}').textContent;
    variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;
    document.querySelector('#Variants-{{ section.id }}').addEventListener('change', function(event) {
      hiddenInput.value = event.currentTarget.value;
    });
});


// triggers when gallery is ready
document.addEventListener('galleryReady:covetPics', function(e) {
    // prepare CSS styles to inject
    const stylesPopup = document.createElement( 'style' )
    stylesPopup.innerHTML = `
    .gallery.grid {
      display: flex !important;
      justify-content: center;
    }
    .gallery covet-pics-gallery-item.grid-item {
      width: 33.33333%;
    }
    `
    // get Covet gallery elements where you want to inject CSS (for eg. covet-pics-widget, covet-pics-popup, covet-pics-upload)
    const popup = document.querySelector("covet-pics-widget");
    
    // now inject CSS code into shadow DOM
    popup.shadowRoot.appendChild(stylesPopup);
});

window.addEventListener("load", function(){
    var yotpoIsReady = false;
    var count=0;
    (function checkForYotpo() {
        setTimeout(function() {
            if (typeof yotpo !== "undefined") {
                if (yotpo.initialized === true) {
                  var ratingContent = document.querySelector(".yotpo-filter-stars .sr-only").innerText;
                  if (ratingContent.includes('0.0')){
                            yotpoIsReady = true;
                            document.getElementsByClassName('yotpo-main-widget')[0].style.display='none';
                            document.getElementsByClassName('yotpo-bottomline')[0].style.display='none';
                            yotpo.refreshWidgets();
                  }
                }
            } else {
                console.log('Checking for Yotpo...');
            }
            if (yotpoIsReady === false && count<10) {
            checkForYotpo();
            count=count+1;
            }
        }, 500);
    })();
});